(() => {
function init(root) {
 if (!root || root.dataset.ready) return;
 root.dataset.ready = 'true';
 const config = JSON.parse(root.querySelector('[data-studio-config]').textContent);
 if (!config.stones.length) return;
const stones = config.stones;
const chipSupported = stones.map(stone => Boolean(stone.chipProduct));
const photo = root.querySelector('#stone-photo');
const stage = root.querySelector('.photo-bracelet');
const status = root.querySelector('#preview-status');
let current = { stone: 0, style: 'round' };
let desired = { ...current };
let request = 0;
const loaded = new Map();
function sourceFor(stone, style) {
  return stone[style];
}
function loadImage(source) {
  if (!loaded.has(source)) {
    const promise = new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Preview image unavailable'));
      image.src = source;
    });
    loaded.set(source, promise);
    promise.catch(() => loaded.delete(source));
  }
  return loaded.get(source);
}
function updateControls() {
  root.querySelectorAll('[data-style]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.style === desired.style));
  });
  root.querySelectorAll('[data-stone]').forEach(button => {
    button.hidden = desired.style === 'chip' && !chipSupported[Number(button.dataset.stone)];
    button.setAttribute('aria-pressed', String(Number(button.dataset.stone) === desired.stone));
  });
}
async function select(next) {
  desired = { ...desired, ...next };
  let switchedStone = false;
  if (desired.style === 'chip' && !chipSupported[desired.stone]) {
    const firstAvailable = chipSupported.indexOf(true);
    if (firstAvailable < 0) desired.style = 'round';
    else { desired.stone = firstAvailable; switchedStone = true; }
  }
  const choice = { ...desired };
  const ticket = ++request;
  const stone = stones[choice.stone];
  const source = sourceFor(stone, choice.style);
  updateControls();
  stage.setAttribute('aria-busy', 'true');
  status.textContent = 'Loading your stone…';
  try {
    await loadImage(source);
    if (ticket !== request) return;
    current = choice;
    root.querySelector('#acrylic-category').hidden = current.style !== 'chip';
    renderCharms();
    photo.src = source;
    photo.alt = `${stone.name} ${choice.style === 'round' ? 'round bead' : 'chipstone'} bracelet design preview with a silver Sandy T tag`;
    root.querySelector('#selection-name').textContent = stone.name;
    root.querySelector('#selection-style').textContent = choice.style === 'round' ? 'Round beads' : 'Chipstones';
    status.textContent = switchedStone ? `Showing ${stone.name}, available as chipstones.` : '';
  } catch (error) {
    if (ticket !== request) return;
    desired = { ...current };
    updateControls();
    status.textContent = 'That preview could not load. Please try again.';
  } finally {
    if (ticket === request) { stage.setAttribute('aria-busy', 'false'); updateOrdering(); }
  }
}
stones.forEach((stone, index) => {
  const button = document.createElement('button');
  button.type = 'button';
  button.dataset.stone = index;
  const swatch = document.createElement('span');
  swatch.className = 'swatch';
  swatch.style.backgroundColor = stone.colour;
  swatch.setAttribute('aria-hidden', 'true');
  button.append(swatch, document.createTextNode(stone.name));
  button.addEventListener('click', () => select({ stone: index }));
  const preload = () => loadImage(sourceFor(stone, desired.style)).catch(() => {});
  button.addEventListener('pointerenter', preload);
  button.addEventListener('focus', preload);
  root.querySelector('#stones').append(button);
});
root.querySelectorAll('[data-style]').forEach(button => {
  button.addEventListener('click', () => select({ style: button.dataset.style }));
});
updateControls();

// Each viewBox shows one original photographed charm from the supplied reference.
// Future charm collections can provide their own artwork and optional product IDs.
const initialBounds = [
  [85,25,135,215],[335,25,125,220],[560,20,200,230],[865,25,160,220],[1160,30,130,215],
  [90,285,130,250],[325,280,155,260],[560,300,185,245],[875,285,140,250],[1125,310,140,240],
  [80,550,160,245],[335,550,135,245],[550,560,210,235],[850,550,160,250],[1110,545,165,255],
  [75,805,155,285],[300,825,180,285],[560,830,160,265],[850,810,160,290],[1120,820,145,280],
  [45,1150,180,255],[305,1150,185,255],[550,1165,185,240],[775,1150,165,255],[960,1145,160,260],[1165,1140,155,255]
];
const charms = [];
let charmId = 0;
// Use extracted silhouettes only; retain the original product photograph's colours.
let charmMaskId = 0;
function applyCharmCutout(svg, photo, family, width, height) {
 const ns='http://www.w3.org/2000/svg';
 const id=`studio-cutout-${++charmMaskId}`;
 const defs=document.createElementNS(ns,'defs');
 const filter=document.createElementNS(ns,'filter');
 filter.id=id+'-edge';
 const transfer=document.createElementNS(ns,'feComponentTransfer');
 const alpha=document.createElementNS(ns,'feFuncA');
 alpha.setAttribute('type','discrete');alpha.setAttribute('tableValues','0 0 1 1');
 transfer.append(alpha);filter.append(transfer);defs.append(filter);
 const mask=document.createElementNS(ns,'mask');mask.id=id;
 mask.setAttribute('maskUnits','userSpaceOnUse');mask.setAttribute('x','0');mask.setAttribute('y','0');
 mask.setAttribute('width',width);mask.setAttribute('height',height);mask.style.maskType='alpha';
 const silhouette=document.createElementNS(ns,'image');
 silhouette.setAttribute('href',config.assets['crystal-hearts-reference.png'].replace(/sandy-studio-crystal-hearts-reference\.png(?:\?.*)?$/,`sandy-studio-charm-${family}-alpha.png`));
 silhouette.setAttribute('width',width);silhouette.setAttribute('height',height);
 silhouette.setAttribute('preserveAspectRatio','none');silhouette.setAttribute('filter',`url(#${id}-edge)`);
 mask.append(silhouette);defs.append(mask);svg.append(defs);
 photo.setAttribute('mask',`url(#${id})`);
}
function constrainCharmArtwork(svg){
 const ns='http://www.w3.org/2000/svg';
 const [x,y,w,h]=svg.getAttribute('viewBox').split(/\s+/).map(Number);
 const id=`studio-art-bounds-${++charmMaskId}`;
 const defs=document.createElementNS(ns,'defs');
 const clip=document.createElementNS(ns,'clipPath');clip.id=id;
 const rect=document.createElementNS(ns,'rect');
 for(const [key,value] of Object.entries({x,y,width:w,height:h}))rect.setAttribute(key,value);
 clip.append(rect);defs.append(clip);
 const group=document.createElementNS(ns,'g');group.setAttribute('clip-path',`url(#${id})`);
 for(const child of [...svg.children])if(child.tagName.toLowerCase()!=='defs')group.append(child);
 svg.append(defs,group);
}
// The photographed round bracelet has 22 beads: two bead pitches per charm.
function charmPosition(index,count,style,acrylicOnly=false){
 const step=acrylicOnly?20:720/22;
 const angle=(index-(count-1)/2)*step*Math.PI/180;
 return {x:50.7+28.1*Math.sin(angle),y:47.8+28.2*Math.cos(angle)-(acrylicOnly?0:1.4)};
}

function initialArtwork(letter) {
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('viewBox', initialBounds[letter.charCodeAt(0) - 65].join(' '));
  svg.setAttribute('preserveAspectRatio', 'xMidYMin meet');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('initial-art');
  const image = document.createElementNS(svgNS, 'image');
  image.setAttribute('href', config.assets["crystal-initials-reference.png"]);
  image.setAttribute('width', '1346');
  image.setAttribute('height', '1422');
  applyCharmCutout(svg,image,'initials',1346,1422);
  svg.append(image);
  constrainCharmArtwork(svg);
  return svg;
}
function renderCharms(message) {
  updateCharmFeedback(message);
  updateOrdering();
  const layer = root.querySelector('#bracelet-charms');
  const list = root.querySelector('#selected-charms');
  layer.replaceChildren();
  list.replaceChildren();
  const activeCharms = charms.filter(charm => charm.type !== 'acrylic' || current.style === 'chip');
  photo.style.maskImage = 'none';
  photo.style.webkitMaskImage = 'none';
  charms.forEach((charm, index) => {
    const activeIndex = activeCharms.indexOf(charm);
    const position = charmPosition(activeIndex,activeCharms.length,current.style,activeCharms.every(item=>item.type==='acrylic'));
    const hanging = document.createElement('span');
    hanging.className = charm.type === 'acrylic' ? 'hanging-initial acrylic-bead' : 'hanging-initial';
    if(charm.type==='engraving' && charm.shape===1)hanging.classList.add('large-engraving');
    hanging.style.left = `${position.x}%`;
    hanging.style.top = `${position.y}%`;
    hanging.append(charm.type === 'acrylic' ? acrylicArtwork(charm.letter) : charm.type === 'engraving' ? engravingArtwork(charm) : charm.type === 'crystal-heart' ? heartArtwork(charm.heart) : initialArtwork(charm.letter));
    if (activeIndex >= 0) layer.append(hanging);
    const entry = document.createElement('div');
    entry.className = 'selected-initial';
    const label = document.createElement('span');
    label.textContent = charm.label + (activeIndex < 0 ? ' · saved for chipstones' : '');
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.textContent = '×';
    remove.setAttribute('aria-label', `Remove ${charm.label}, charm ${index + 1}`);
    remove.addEventListener('click', () => {
      charms.splice(charms.findIndex(item => item.id === charm.id), 1);
      renderCharms(`${charm.label} removed.`);
      const picker = root.querySelector(`[data-charm="${charm.key}"]`);
      picker.closest('details').open = true;
      picker.focus();
    });
    entry.dataset.selectedId = charm.id;
    entry.tabIndex = -1;
    const moves = [-1, 1].map(direction => {
      const move = document.createElement('button');
      move.type = 'button';
      move.textContent = direction < 0 ? '←' : '→';
      move.setAttribute('aria-label', `Move ${charm.label} ${direction < 0 ? 'left' : 'right'}`);
      move.disabled = index + direction < 0 || index + direction >= charms.length;
      move.addEventListener('click', () => {
        const from = charms.findIndex(item => item.id === charm.id);
        const to = from + direction;
        if (from < 0 || to < 0 || to >= charms.length) return;
        [charms[from], charms[to]] = [charms[to], charms[from]];
        renderCharms(`${charm.label} moved to position ${to + 1}.`);
        root.querySelector(`[data-selected-id="${charm.id}"]`).focus();
      });
      return move;
    });
    const handle = document.createElement('button');
    handle.type = 'button';
    handle.className = 'drag-handle';
    handle.textContent = '⠿';
    handle.setAttribute('aria-label', `Drag ${charm.label} to reorder, or use the arrow buttons`);
    handle.addEventListener('pointerdown', event => startCharmDrag(event, charm.id, entry, handle));
    entry.append(handle, label, ...moves, remove);
    if (charm.type === 'engraving') {
      const editor = document.createElement('div');
      editor.className = 'engraving-editor';
      const fieldLabel = document.createElement('label');
      fieldLabel.textContent = 'Your engraving';
      const input = document.createElement('input');
      input.type = 'text';
      input.maxLength = engravingShapes[charm.shape].max;
      input.placeholder = 'Initials, a name or a short message';
      input.value = charm.text;
      input.addEventListener('input', () => {
        charm.text = input.value;
        updateOrdering();
        root.querySelectorAll(`[data-engraving-id="${charm.id}"]`).forEach(text => setEngravingText(text, charm));
      });
      fieldLabel.append(input);
      const zoom = document.createElement('details');
      zoom.className = 'engraving-zoom';
      zoom.open = true;
      const summary = document.createElement('summary');
      summary.textContent = 'Close-up engraving preview';
      zoom.append(summary, engravingArtwork(charm));
      const note = document.createElement('p');
      note.className = 'note';
      note.textContent = `Libre Baskerville · up to ${engravingShapes[charm.shape].max} characters maximum. Placement is an illustrative preview.`;
      editor.append(fieldLabel, zoom, note);
      entry.append(editor);
    }
    list.append(entry);
  });
  root.querySelectorAll('[data-charm]').forEach(button => { button.disabled = charms.length >= config.maxCharms || button.dataset.unavailable === 'true'; });
  root.querySelector('#clear-charms').hidden = charms.length === 0;
  const count = charms.length ? `${charms.length} of ${config.maxCharms} charms: ${charms.map(item => item.label).join(', ')}.` : 'No charms added yet.';
  root.querySelector('#charm-status').textContent = [message, count].filter(Boolean).join(' ');
}
function startCharmDrag(event, id, row, handle) {
  if (event.button !== 0 || charms.length < 2) return;
  event.preventDefault();
  const list = root.querySelector('#selected-charms');
  const startY = event.clientY;
  const from = charms.findIndex(charm => charm.id === id);
  let target = from;
  let moved = false;
  handle.setPointerCapture(event.pointerId);
  row.classList.add('is-dragging');
  function clearTargets() {
    list.querySelectorAll('.drop-before, .drop-after').forEach(item => item.classList.remove('drop-before', 'drop-after'));
  }
  function onMove(move) {
    if (move.pointerId !== event.pointerId) return;
    moved = moved || Math.abs(move.clientY - startY) > 5;
    row.style.transform = `translateY(${move.clientY - startY}px)`;
    const others = [...list.children].filter(item => item !== row);
    target = others.filter(item => move.clientY > item.getBoundingClientRect().top + item.getBoundingClientRect().height / 2).length;
    clearTargets();
    if (others[target]) others[target].classList.add('drop-before');
    else if (others.length) others[others.length - 1].classList.add('drop-after');
  }
  function finish(end) {
    if (end.pointerId !== event.pointerId) return;
    handle.removeEventListener('pointermove', onMove);
    handle.removeEventListener('pointerup', finish);
    handle.removeEventListener('pointercancel', finish);
    handle.removeEventListener('lostpointercapture', finish);
    if (handle.hasPointerCapture(event.pointerId)) handle.releasePointerCapture(event.pointerId);
    clearTargets();
    row.classList.remove('is-dragging');
    row.style.transform = '';
    if (end.type === 'pointerup' && moved && target !== from) {
      const [charm] = charms.splice(from, 1);
      charms.splice(target, 0, charm);
      renderCharms(`${charm.label} moved to position ${target + 1}.`);
      root.querySelector(`[data-selected-id="${id}"] .drag-handle`).focus();
    }
  }
  handle.addEventListener('pointermove', onMove);
  handle.addEventListener('pointerup', finish);
  handle.addEventListener('pointercancel', finish);
  handle.addEventListener('lostpointercapture', finish);
}
[...new Set(config.initialLetters.replace(/[^A-Z]/g, ''))].forEach(letter => {
  const button = document.createElement('button');
  button.type = 'button';
  button.dataset.initial = letter;
  button.dataset.charm = `initial-${letter}`;
  button.setAttribute('aria-label', `Add crystal initial ${letter}`);
  const label = document.createElement('span');
  label.textContent = letter;
  button.append(initialArtwork(letter), label);
  button.addEventListener('click', () => {
    if (charms.length >= config.maxCharms) return;
    charms.push({ id: ++charmId, type: 'crystal-initial', letter, key: `initial-${letter}`, label: `${letter} initial` });
    renderCharms(`${letter} added.`);
  });
  root.querySelector('#initials').append(button);
});
root.querySelector('#clear-charms').addEventListener('click', () => {
  charms.length = 0;
  renderCharms('All charms removed.');
  root.querySelector('.charm-category summary').focus();
});

const hearts = config.hearts.map(item => [item.name, ...item.position]);
function heartArtwork(index) {
  const [,x,y] = hearts[index];
  if(config.hearts[index].image) { const img = document.createElement("img"); img.className="initial-art"; img.src=config.hearts[index].image; img.alt=""; return img; }
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns,'svg');
  svg.classList.add('initial-art');
  svg.setAttribute('viewBox', `${x-60} ${y-150} 120 210`);
  svg.setAttribute('preserveAspectRatio','xMidYMin meet');
  svg.setAttribute('aria-hidden','true');
  const image = document.createElementNS(ns,'image');
  image.setAttribute('href',config.assets["crystal-hearts-reference.png"]);
  image.setAttribute('width','956');
  image.setAttribute('height','960');
  image.setAttribute('transform',`rotate(${-30*config.hearts[index].artIndex} ${x} ${y})`);
  applyCharmCutout(svg,image,'hearts',956,960);
  svg.append(image);
  constrainCharmArtwork(svg);
  return svg;
}
hearts.forEach((heart,index) => {
  const button = document.createElement('button');
  button.type = 'button';
  button.dataset.charm = `heart-${index}`;
  button.setAttribute('aria-label',`Add ${heart[0].toLowerCase()} crystal heart`);
  const label = document.createElement('span');
  label.textContent = heart[0];
  button.append(heartArtwork(index),label);
  button.addEventListener('click',() => {
    if(charms.length >= config.maxCharms) return;
    const name = `${heart[0]} heart`;
    charms.push({id:++charmId,type:'crystal-heart',heart:index,key:`heart-${index}`,label:name});
    renderCharms(`${name} added.`);
  });
  root.querySelector('#hearts').append(button);
});

const engravingShapes = config.engravings;
function setEngravingText(text, charm) {
  const shape = engravingShapes[charm.shape];
  text.textContent = charm.text;
  text.setAttribute('font-size', Math.min(25, shape.width / Math.max(1, [...charm.text].length) / .78));
}
function engravingArtwork(charm) {
  const shape = engravingShapes[charm.shape];
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns,'svg');
  svg.classList.add('initial-art');
  svg.setAttribute('viewBox',shape.box.join(' '));
  svg.setAttribute('preserveAspectRatio','xMidYMin meet');
  svg.setAttribute('role','img');
  svg.setAttribute('aria-label',`${shape.name} engraving preview`);
  const photo = document.createElementNS(ns,'image');
  photo.setAttribute('href',shape.image || config.assets["engraving-reference.png"]);
  photo.setAttribute('width','768');
  photo.setAttribute('height','806');
  const text = document.createElementNS(ns,'text');
  text.dataset.engravingId = charm.id;
  text.setAttribute('x',shape.x);
  text.setAttribute('y',shape.y);
  text.setAttribute('text-anchor','middle');
  text.setAttribute('dominant-baseline','middle');
  text.setAttribute('fill','#55514e');
  text.setAttribute('font-family','Libre Baskerville, Georgia, serif');
  setEngravingText(text,charm);
  applyCharmCutout(svg,photo,'engraving',768,806);
  svg.append(photo,text);
  constrainCharmArtwork(svg);
  return svg;
}
engravingShapes.forEach((shape,index) => {
  const button = document.createElement('button');
  button.type = 'button';
  button.dataset.charm = `engraving-${index}`;
  button.setAttribute('aria-label',`Add engravable ${shape.name.toLowerCase()}`);
  const label = document.createElement('span');
  label.textContent = shape.name;
  button.append(engravingArtwork({shape:index,id:`sample-${index}`,text:''}),label);
  button.addEventListener('click',() => {
    if(charms.length >= config.maxCharms) return;
    charms.push({id:++charmId,type:'engraving',shape:index,key:`engraving-${index}`,label:shape.name,text:''});
    renderCharms(`${shape.name} added. Enter your engraving below.`);
    root.querySelector(`[data-selected-id="${charmId}"] input`).focus();
  });
  root.querySelector('#engravables').append(button);
});

const acrylicBounds = [[42, 66, 196, 196], [232, 76, 196, 196], [422, 76, 196, 196], [611, 76, 196, 196], [802, 77, 196, 196], [1000, 83, 196, 196], [39, 316, 196, 196], [231, 327, 196, 196], [423, 325, 196, 196], [619, 328, 196, 196], [814, 328, 196, 196], [1011, 335, 196, 196], [41, 582, 196, 196], [231, 577, 196, 196], [425, 574, 196, 196], [624, 582, 196, 196], [821, 586, 196, 196], [1019, 589, 196, 196], [41, 822, 196, 196], [234, 825, 196, 196], [428, 825, 196, 196], [626, 832, 196, 196], [826, 844, 196, 196], [1024, 847, 196, 196], [42, 1036, 196, 196], [236, 1048, 196, 196]];
function acrylicArtwork(letter) {
 const ns='http://www.w3.org/2000/svg';
 const svg=document.createElementNS(ns,'svg');
 svg.classList.add('initial-art');
 svg.setAttribute('viewBox',acrylicBounds[letter.charCodeAt(0)-65].join(' '));
 svg.setAttribute('aria-hidden','true');
 const image=document.createElementNS(ns,'image');
 image.setAttribute('href',config.assets["acrylic-cutouts.png"]);
 image.setAttribute('width','1247');image.setAttribute('height','1261');
 svg.style.clipPath = 'ellipse(47% 47% at 50% 50%)';
 svg.append(image);constrainCharmArtwork(svg);return svg;
}
[...new Set(config.acrylicLetters.replace(/[^A-Z]/g, ''))].forEach(letter=>{
 const button=document.createElement('button');button.type='button';
 button.dataset.charm=`acrylic-${letter}`;
 button.setAttribute('aria-label',`Add white acrylic ${letter}`);
 const label=document.createElement('span');label.textContent=letter;
 button.append(acrylicArtwork(letter),label);
 button.addEventListener('click',()=>{
  if(current.style !== 'chip' || charms.length >= config.maxCharms)return;
  charms.push({id:++charmId,type:'acrylic',letter,key:`acrylic-${letter}`,label:`Acrylic ${letter}`});
  renderCharms(`Acrylic ${letter} added.`);
 });
 root.querySelector('#acrylic').append(button);
});


const feedbackBar = document.createElement('nav');
feedbackBar.className = 'charm-feedback';
feedbackBar.setAttribute('aria-label', 'Your bracelet shortcuts');
const feedbackMessage = document.createElement('span');
feedbackMessage.className = 'charm-feedback-message';
const previewShortcut = document.createElement('button');
previewShortcut.type = 'button';
const reviewShortcut = document.createElement('button');
reviewShortcut.type = 'button';
reviewShortcut.textContent = 'Review charms';
function jumpToStudio(target) {
  target.tabIndex = -1;
  target.focus({preventScroll:true});
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
}
previewShortcut.addEventListener('click', () => jumpToStudio(stage));
reviewShortcut.addEventListener('click', () => jumpToStudio(root.querySelector('#selected-charms')));
const stickyPrices = document.createElement('div');
stickyPrices.className='charm-feedback-prices';
stickyPrices.setAttribute('aria-live','polite');
feedbackBar.append(stickyPrices, feedbackMessage, previewShortcut, reviewShortcut);
root.querySelector('main').append(feedbackBar);

function priceCharmFromKey(key) {
 const [type,value]=key.split('-');
 if(type==='initial')return {type:'crystal-initial',letter:value};
 if(type==='acrylic')return {type:'acrylic',letter:value};
 if(type==='heart')return {type:'crystal-heart',heart:Number(value)};
 return {type:'engraving',shape:Number(value)};
}
function showStickyPrice(base,extras,total,format) {
 stickyPrices.replaceChildren();
 const detail=document.createElement('span'),sum=document.createElement('strong');
 detail.textContent=base==null?'Loading prices…':`Bracelet ${format(base)} · Charms ${extras==null?'—':format(extras)}`;
 sum.textContent=total==null?'Total —':`Total ${format(total)}`;
 stickyPrices.append(detail,sum);
}
function updateCharmPriceLabels(){
 root.querySelectorAll('[data-charm]').forEach(button=>{
  const variant=charmVariant(priceCharmFromKey(button.dataset.charm));
  let label=button.querySelector('.charm-option-price');if(!label){label=document.createElement('span');label.className='charm-option-price';button.append(label);}
  label.textContent=loadingProducts?'Loading…':!variant?'Unavailable':!variant.available?'Sold out':`+${money(variant.price)} each`;
  button.dataset.baseAddLabel ||= button.dataset.addLabel || button.getAttribute('aria-label');
  button.dataset.addLabel=button.dataset.baseAddLabel+`, ${label.textContent}`;
  const count=charms.filter(c=>c.key===button.dataset.charm).length;
  button.setAttribute('aria-label',button.dataset.addLabel+(count?`, ${count} selected`:''));
  button.dataset.unavailable=String(loadingProducts || !variant?.available);
  button.disabled=button.dataset.unavailable==='true'||charms.length>=config.maxCharms;
 });
}

let feedbackTimer;
function updateCharmFeedback(message) {
  const active = charms.filter(c => c.type !== 'acrylic' || current.style === 'chip').length;
  previewShortcut.textContent = `Your bracelet · ${active} ${active === 1 ? 'charm' : 'charms'}`;
  previewShortcut.setAttribute('aria-label', `View bracelet preview, ${active} ${active === 1 ? 'charm' : 'charms'}`);
  reviewShortcut.disabled = !charms.length;
  root.querySelectorAll('[data-charm]').forEach(button => {
    const quantity = charms.filter(c => c.key === button.dataset.charm).length;
    let badge = button.querySelector('.charm-count-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'charm-count-badge';
      badge.setAttribute('aria-hidden','true');
      button.append(badge);
      button.dataset.addLabel = button.dataset.addLabel || button.getAttribute('aria-label');
    }
    badge.textContent = quantity;
    badge.hidden = !quantity;
    button.classList.toggle('has-selected-charm', quantity > 0);
    button.setAttribute('aria-label', button.dataset.addLabel + (quantity ? `, ${quantity} selected` : ''));
  });
  clearTimeout(feedbackTimer);
  feedbackMessage.textContent = message ? `✓ ${message}` : (charms.length >= config.maxCharms ? 'Your bracelet is full · review to make changes' : 'Tap a charm to add it');
  feedbackBar.classList.toggle('just-updated', Boolean(message));
  if(message) feedbackTimer = setTimeout(() => {
    feedbackMessage.textContent = charms.length >= config.maxCharms ? 'Your bracelet is full · review to make changes' : 'Your choices are saved in this preview';
    feedbackBar.classList.remove('just-updated');
  }, 3200);
}
updateCharmFeedback();

const orderPanel = document.createElement('section');
orderPanel.className = 'studio-order';
orderPanel.setAttribute('aria-label','Your bracelet price');
const variantLabel = document.createElement('label');
variantLabel.textContent = 'Bracelet option';
const variantSelect = document.createElement('select');
variantLabel.append(variantSelect);
const priceSummary = document.createElement('dl');
const orderMessage = document.createElement('p');
orderMessage.setAttribute('role','status');
const addDesign = document.createElement('button');
addDesign.type='button'; addDesign.textContent='Add your bracelet to bag';
orderPanel.append(variantLabel,priceSummary,addDesign,orderMessage);
root.querySelector('.preview-footer').before(orderPanel);
let selectedVariantId = null;
let productKey = '';
let submitting = false;
let loadingProducts = true;
const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:config.currency || 'GBP'}).format(cents/100);
function activeDesignCharms(){ return charms.filter(c => c.type !== 'acrylic' || current.style === 'chip'); }
function braceletProduct(){ return stones[current.stone][current.style === 'chip' ? 'chipProduct' : 'roundProduct']; }
function charmVariant(c){
 let p, title;
 if(c.type==='crystal-initial'){p=config.initialProduct;title=c.letter;}
 else if(c.type==='acrylic'){p=config.acrylicProduct;title=c.letter;}
 else if(c.type==='crystal-heart'){p=config.hearts[c.heart].product;title=config.hearts[c.heart].name;}
 else {p=config.engravings[c.shape].product;}
 const variants=p?.variants || [];
 return title ? variants.find(v => v.title===title || (v.options?.length===1 && v.options[0]===title)) : (variants.length===1 ? variants[0] : null);
}
function designState(){
 const p=braceletProduct();
 const bracelet=p?.variants?.find(v=>String(v.id)===String(selectedVariantId));
 const selected=activeDesignCharms().map(c=>({charm:c,variant:charmVariant(c)}));
 let problem='';
 if(loadingProducts)problem='Loading prices and availability…';
 else if(!bracelet)problem='This bracelet is not connected for ordering yet.';
 else if(!bracelet.available)problem='This bracelet option is sold out.';
 else if(selected.some(x=>!x.variant))problem='One or more charms are not connected for ordering yet.';
 else if(selected.some(x=>!x.variant.available))problem='One of your charms is sold out. Please choose another.';
 else if(selected.some(x=>x.charm.type==='engraving' && x.charm.text.length > (config.engravings[x.charm.shape].max || (x.charm.shape===1?12:8))))problem='Please shorten your engraving to the limit shown for that charm.';
 else if(selected.some(x=>x.charm.type==='engraving' && !x.charm.text.trim()))problem='Please enter the text for each engraved charm.';
 const charmTotal=selected.reduce((sum,x)=>sum+(x.variant?.price || 0),0);
 return {bracelet,selected,problem,charmTotal};
}
function updateOrdering(){
 const p=braceletProduct();
 const key=`${current.style}:${p?.id || ''}:${current.stone}`;
 if(key!==productKey){
  productKey=key;variantSelect.replaceChildren();
  (p?.variants || []).forEach(v=>{
   const option=document.createElement('option');option.value=v.id;
   option.textContent=v.title+(v.available?'':' · sold out');variantSelect.append(option);
  });
  selectedVariantId=(p?.variants?.find(v=>v.available) || p?.variants?.[0])?.id || null;
  if(selectedVariantId)variantSelect.value=selectedVariantId;
 }
 variantLabel.hidden=!(p?.variants?.length>1);
 const state=designState();priceSummary.replaceChildren();
 updateCharmPriceLabels();
 const pricesKnown=!loadingProducts && state.bracelet && state.selected.every(x=>x.variant);
 showStickyPrice(loadingProducts?null:state.bracelet?.price,pricesKnown?state.charmTotal:null,pricesKnown?state.bracelet.price+state.charmTotal:null,money);
 const complete=state.bracelet && state.selected.every(x=>x.variant);
 [['Price',state.bracelet ? money(state.bracelet.price):'Not connected'],['Charms',state.selected.every(x=>x.variant)?money(state.charmTotal):'Not connected'],['Total',complete?money(state.bracelet.price+state.charmTotal):'—']].forEach(([label,value])=>{
  const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;priceSummary.append(dt,dd);
 });
 addDesign.disabled=submitting || !config.orderingEnabled || Boolean(state.problem) || stage.getAttribute('aria-busy')==='true';
 orderMessage.textContent=state.problem || (!config.orderingEnabled?'Ordering is being prepared. Your design is a preview.':'');
}
const sampleSelect=root.querySelector('[data-free-sample]');
sampleSelect?.addEventListener('change',()=>{root.querySelector('[data-sample-status]').textContent=sampleSelect.value ? `${sampleSelect.value} — included free when you add your bracelet.` : '';});
variantSelect.addEventListener('change',()=>{selectedVariantId=variantSelect.value;updateOrdering();});
addDesign.addEventListener('click',async()=>{
 const state=designState();if(submitting || !config.orderingEnabled || state.problem)return;
 submitting=true;updateOrdering();addDesign.textContent='Adding your design…';
 const group=crypto.randomUUID();
 const properties={_studio_design:group,'Stone':stones[current.stone].name,'Style':current.style==='chip'?'Chipstones':'Round beads','Charm order':state.selected.map((x,i)=>`${i+1}. ${x.charm.label}${x.charm.type==='engraving'?` — ${x.charm.text}`:''}`).join('; ') || 'No charms'};
 if(sampleSelect?.value) properties['Free fragrance sample']=sampleSelect.value;
 const items=[{id:state.bracelet.id,quantity:1,properties},...state.selected.map(({charm,variant},i)=>({id:variant.id,quantity:1,parent_id:state.bracelet.id,properties:{_studio_design:group,'Position':String(i+1),...(charm.type==='engraving'?{'Engraving':charm.text,'Engraving font':'Libre Baskerville'}:{})}}))];
 const drawer=document.querySelector('cart-drawer');
 const drawerSections=drawer?.getSectionsToRender?.() || [];
 drawer?.setActiveElement?.(addDesign);
 try{
  const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,...(drawerSections.length?{sections:[...new Set(drawerSections.map(section=>section.section))],sections_url:window.location.pathname}:{})})});
  const result=await response.json();if(!response.ok)throw Error(result.description || 'Your design could not be added. Please check availability.');
  if(drawerSections.length && drawerSections.every(section=>result.sections?.[section.section])){
   try{
    drawer.renderContents(result);
    orderMessage.textContent='Your bracelet has been added to your bag.';
   }catch(drawerError){
    // The design is already added: recover without submitting it twice.
    window.location.assign((window.Shopify?.routes?.root || '/')+'cart');
   }
  }else{
   window.location.assign((window.Shopify?.routes?.root || '/')+'cart');
  }
 }catch(error){orderMessage.textContent=error.message;}
 finally{submitting=false;addDesign.textContent='Add your bracelet to bag';addDesign.disabled=!config.orderingEnabled || Boolean(designState().problem);}
});
updateOrdering();

// Match the referring product against the actual configured Studio products.
// Unknown or removed products safely keep the default selection.
const referringProduct = new URLSearchParams(window.location.search).get('studio_product');
let initialChoice = {stone:0,style:'round'};
if (referringProduct) {
 stones.some((stone,index) => ['round','chip'].some(style => {
  const product = stone[style === 'chip' ? 'chipProduct' : 'roundProduct'];
  const handle = typeof product === 'string' ? product : product?.handle;
  if (handle !== referringProduct) return false;
  initialChoice = {stone:index,style};
  return true;
 }));
}
select(initialChoice);
// Shopify serializes product settings as handles. Resolve current storefront
// variants so Shopify remains the source of truth for prices and availability.
const productRequests = new Map();
async function resolveProduct(value) {
 if (!value || typeof value !== 'string') return value;
 if (!productRequests.has(value)) productRequests.set(value, (async () => {
  const response = await fetch((window.Shopify?.routes?.root || '/')+'products/'+encodeURIComponent(value)+'.js');
  if (!response.ok) throw Error('Product unavailable');
  return response.json();
 })());
 try { return await productRequests.get(value); } catch { return null; }
}
const connections = [[config,'initialProduct'],[config,'acrylicProduct'],
 ...stones.flatMap(stone=>[[stone,'roundProduct'],[stone,'chipProduct']]),
 ...config.hearts.map(heart=>[heart,'product']),
 ...config.engravings.map(charm=>[charm,'product'])];
Promise.all(connections.map(async ([owner,key])=>{owner[key]=await resolveProduct(owner[key]);})).finally(()=>{
 loadingProducts=false;productKey='';updateOrdering();
});
}
document.querySelectorAll('[data-sandy-studio]').forEach(init);
if (!window.sandyStudioListener) {
 window.sandyStudioListener = true;
 document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-sandy-studio]').forEach(init));
}
})();
